import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import Card from '@molecules/contents/NoticePageBox';

import BackBtn from '@app/components/atoms/btn/BackBtn';

import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useMobxStores } from '@stores/store';
import classnames from 'classnames';
import Pagination from '@molecules/pagination/Pagination';
import PaginationBar from '@molecules/pagination/Bar';
import { has as _has, isEmpty as _isEmpty } from 'lodash';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import queryString from 'query-string';

import { useTranslation } from 'react-i18next';
import Navigation from '@atoms/Navigation';
import NoticeBox from '@molecules/contents/NoticeBox';
import NoticePageBox from '@molecules/contents/NoticePageBox';
import BoardHeader from '@organisms/community/BoardHeader';

const Board = ({ type }) => {
  const { communityStore } = useMobxStores();
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [isSearch, setIsSearch] = useState(false);
  const [keywords, setKeywords] = useState('');
  const [boardPage, setBoardBPage] = useState(1);
  const [boardTotal, setBoardTotal] = useState(0);

  let query = queryString.parse(location.search);

  useEffect(() => {
    if (type === 'news') {
      setBoardTotal(communityStore.noticeList.totalPages);
      setBoardBPage(communityStore.noticeList.page);
    }

    if (type === 'event') {
      setBoardTotal(communityStore.eventList.totalPages);
      setBoardBPage(communityStore.eventList.page);
    }

    if (isSearch) {
      setBoardTotal(communityStore.searchList.totalPages);
      setBoardBPage(communityStore.searchList.page);

      if (communityStore.searchList.contents.length == 0) {
        setBoardTotal(0);
      }
    }
  }, [type, isSearch, query]);

  const onChangePageNumber = (e, value) => {
    if (e != null) e.preventDefault();
    let query = queryString.parse(location.search);
    query.page = value;
    getSearchData(value);
    navigate('?' + queryString.stringify(query));
  };

  const onChange = e => {
    const { value, name } = e.target; // 우선 e.target 에서 name 과 value 를 추출

    if (value == '') {
      setIsSearch(false);
    }
    e.target.value = ('' + e.target.value).trim();
    setKeywords(value);
  };

  const handelReset = () => {
    setIsSearch(false);
    setKeywords('');
    setBoardBPage(1);
    setBoardTotal(1);

    navigate('?');
  };

  const handelSearch = async () => {
    if (keywords === '') {
      handelReset();
    } else {
      await getSearchData();

      if (!_isEmpty(communityStore.searchList)) {
        query.keyword = keywords;
        query.page = communityStore.searchList?.query.page;
        navigate('?' + queryString.stringify(query));
      }
    }

    return true;
  };

  const getSearchData = async value => {
    setIsSearch(true);
    const query = queryString.parse(location.search);
    let board = type === 'news' ? 'notice' : 'event';
    communityStore.setListQuery('searchList', {
      ...query,
      page: value ? parseInt(value) : 1,
      lang: i18n.language,
      size: 6,
    });

    await communityStore.getNoticeByKeyword(board, keywords);
  };
  const handleOnKeyDown = event => {
    if (event.key === 'Enter') {
      handelSearch();
    }
  };

  return (
    <>
      <section id="list">
        <div className=" ">
          <div className="relative h-full">
            <input
              type="text"
              name="keyword"
              value={keywords}
              onChange={onChange}
              onKeyDown={handleOnKeyDown}
              className={
                '  shadow appearance-none border-none  w-full py-4 sm:py-5 px-3  leading-tight focus:outline-none focus:shadow-outline'
              }
              placeholder={t(`제목으로 검색하세요.`)}
              maxLength={225}
              //onKeyDown={onKeyDown}
            />
            <span className="absolute top-0 right-0 h-full flex items-center pr-3 h-[60px] cursor-pointer">
              {(!isSearch || keywords === '') && (
                <div className="w-[30px] h-[30px]" onClick={handelSearch}>
                  <img
                    src="/img/v2/svg/search.svg"
                    className="w-[25px]  h-[25px]"
                  />
                </div>
              )}
              {isSearch && keywords.length > 0 && (
                <div className="w-[30px] h-[30px]" onClick={handelReset}>
                  x
                </div>
              )}
            </span>
          </div>

          <div className={classnames('grid grid-cols-1 my-5  ')}>
            {type === 'news' &&
              !isSearch &&
              !_isEmpty(communityStore.noticeList) && (
                <NoticePageBox
                  type={type}
                  data={communityStore.noticeList.contents}
                />
              )}

            {type === 'event' &&
              !isSearch &&
              !_isEmpty(communityStore.eventList) && (
                <NoticePageBox
                  type={type}
                  data
                  data={communityStore.eventList.contents}
                />
              )}
            {isSearch && !_isEmpty(communityStore.searchList) && (
              <NoticePageBox
                type={type}
                data={communityStore.searchList.contents}
              />
            )}
          </div>

          {boardTotal > 0 && (
            <Navigation
              current={boardPage}
              totalPage={boardTotal}
              leftDisabled={boardPage <= 1 ? true : false}
              rightDisabled={boardPage >= boardTotal ? true : false}
              leftOnClick={e =>
                onChangePageNumber(
                  e,
                  boardPage - 1 > 1 ? boardPage - 1 : 1,
                  boardPage >= 1 ? true : false
                )
              }
              rightOnClick={e =>
                onChangePageNumber(
                  e,
                  boardPage + 1 <= boardTotal ? boardPage + 1 : boardTotal,
                  boardPage <= boardTotal ? true : false
                )
              }
            />
          )}
        </div>
      </section>
    </>
  );
};

export default observer(Board);
